/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountBillingCycleQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountBillingCycleQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly billingCycle: GraphQL.Term } | null };


export const AccountBillingCycleDocument = gql`
    query AccountBillingCycle($accountId: AccountId!) {
  account(id: $accountId) {
    id
    billingCycle
  }
}
    `;

/**
 * __useAccountBillingCycleQuery__
 *
 * To run a query within a React component, call `useAccountBillingCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBillingCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBillingCycleQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountBillingCycleQuery(baseOptions: Apollo.QueryHookOptions<AccountBillingCycleQuery, AccountBillingCycleQueryVariables> & ({ variables: AccountBillingCycleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>(AccountBillingCycleDocument, options);
      }
export function useAccountBillingCycleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>(AccountBillingCycleDocument, options);
        }
export function useAccountBillingCycleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>(AccountBillingCycleDocument, options);
        }
export type AccountBillingCycleQueryHookResult = ReturnType<typeof useAccountBillingCycleQuery>;
export type AccountBillingCycleLazyQueryHookResult = ReturnType<typeof useAccountBillingCycleLazyQuery>;
export type AccountBillingCycleSuspenseQueryHookResult = ReturnType<typeof useAccountBillingCycleSuspenseQuery>;
export type AccountBillingCycleQueryResult = Apollo.QueryResult<AccountBillingCycleQuery, AccountBillingCycleQueryVariables>;